import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ApplicationState } from 'store'
import * as navBarActions from 'store/modules/navbar/actions'
import useRedux from 'hooks/useRedux'
import { NAVBAR } from 'store/modules/navbar/types'

const ModalAssociarDesassociar = () => {
  const { acaoModalAssociar, modalAssociarDesassociar, ramalAssociado } =
    useSelector<ApplicationState, NAVBAR>((state) => state.navbar)
  const { dispatch } = useRedux()

  const handleConfirm = () => {
    if (!acaoModalAssociar) return

    dispatch(navBarActions.confirmarAcaoAssociarDesassociarSaga())
  }
  const titulo =
    acaoModalAssociar === 'associar' ? 'Associar Ramal' : 'Desassociar Ramal'

  const toggleModal = () => {
    dispatch(navBarActions.toggleModalAssociarDesassociar(false))
  }

  const mensagem =
    acaoModalAssociar === 'associar'
      ? `Deseja realmente associar este ramal ${ramalAssociado.ramal} a este usuário?`
      : `Deseja realmente desassociar o ramal ${ramalAssociado.ramal} a deste usuário?`

  return (
    <Modal isOpen={modalAssociarDesassociar}>
      <ModalHeader toggle={toggleModal}>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          {titulo}
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <p>{mensagem}</p>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Row className="d-flex column-gap-20">
          <CustomButton onClick={toggleModal} background="#662D91">
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleConfirm}>Confirmar</CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalAssociarDesassociar
